module.exports = __webpack_public_path__ + "static/media/sso-okta.a7ccebb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/sso-okta.png
// module id = 13902
// module chunks = 0